import { render } from "./Legal.vue?vue&type=template&id=19986cb8&scoped=true"
const script = {}

import "./Legal.vue?vue&type=style&index=0&id=19986cb8&scoped=true&lang=css"

import exportComponent from "/working_dir/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19986cb8"]])

export default __exports__